import React from 'react';
import {IapmMappingChange} from '../../../backend/model';
import {operators, TableDetails, TableInput, useTableCreation} from '../../TableTemplate';
import {IapLink, IogLink, RuleLongLink} from '../../TableItemLink';

const TABLE_ID = 'dynamicExecutionPage-iapmsTable';

const COLUMN_DEFINITIONS = [
    {
        id: 'iapId',
        header: 'Inventory Availability Pool Id',
        cell: (iapmMappingChange: IapmMappingChange): JSX.Element => <IapLink iapId={iapmMappingChange.iapId}/>,
        sortingField: 'iapId',
    },
    {
        id: 'iogId',
        header: 'Inventory Owner Group Id',
        cell: (iapmMappingChange: IapmMappingChange): JSX.Element => <IogLink iogId={iapmMappingChange.iogId}/>,
    },
    {
        id: 'fcId',
        header: 'Fulfillment Center Id',
        cell: (iapmMappingChange: IapmMappingChange) => iapmMappingChange.fcId,
    },
    {
        id: 'priority',
        header: 'Priority',
        cell: (iapmMappingChange: IapmMappingChange) => iapmMappingChange.priority ?? "",
    },
    {
        id: 'operation',
        header: 'Operation',
        cell: (iapmMappingChange: IapmMappingChange) => iapmMappingChange.dynamicExecutionOperation,
    },
    {
        id: 'mappingStatus',
        header: 'Mapping Status',
        cell: (iapmMappingChange: IapmMappingChange) => iapmMappingChange.mappingStatus,
    },
    {
        id: 'ruleName',
        header: 'Rule',
        cell: (iapmMappingChange: IapmMappingChange) => <RuleLongLink ruleGroupRuleName={iapmMappingChange.ruleName}/>,
    },
];

const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'IAP',
        key: 'iapId',
        groupValuesLabel: 'IAP ID values',
        operators: operators,
    },
    {
        propertyLabel: 'IOG',
        key: 'iogId',
        groupValuesLabel: 'IOG ID values',
        operators: operators,
    },
    {
        propertyLabel: 'FC',
        key: 'fcId',
        groupValuesLabel: 'FC ID values',
        operators: operators,
    },
    {
        propertyLabel: 'Priority',
        key: 'priority',
        groupValuesLabel: 'Priority values',
        operators: operators,
    },
    {
        propertyLabel: 'Operation',
        key: 'operation',
        groupValuesLabel: 'Operation values',
        operators: operators,
    },
    {
        propertyLabel: 'Mapping Status',
        key: 'mappingStatus',
        groupValuesLabel: 'Mapping Status values',
        operators: operators,
    },
    {
        propertyLabel: 'Rule',
        key: 'ruleName',
        groupValuesLabel: 'Rule name',
        operators: operators,
    },
];

const IapmTable: React.FC<TableInput> = ({tableItems, fileName}) => {
    const tableDetails: TableDetails = {
        tableId: TABLE_ID,
        header: `Changed ${tableItems.length} IAPMs`,
        fileName: fileName,
        getRow: function (row: IapmMappingChange): string[] {
            return [
                row.iapId,
                row.iogId,
                row.fcId,
                row.priority ?? "",
                row.dynamicExecutionOperation,
                row.mappingStatus,
            ];
        },
    };
    return useTableCreation(tableDetails, COLUMN_DEFINITIONS, tableItems, FILTERING_PROPERTIES);
};

export default IapmTable;
